<template>
  <div class="city-wrapper wp-city">
<!--     <div class="vld-parent mycenter">
        <loading :active.sync="isLoading"
        :is-full-page="fullPage"></loading>
    </div>     -->
    <subpage-header>

<!-- <div slot="bread">
<ul itemscope itemtype="http://schema.org/BreadcrumbList">

<li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="https://holywoodskyline.com/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name">holywoodskyline.com</span>
<span class="color-white"> / </span>
</a>
<meta itemprop="position" content="1" />
</li>

<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="city_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
&nbsp;<span itemprop="name">{{ city_name }} Öğrenci Yurtları</span>
</a>
<meta itemprop="position" content="2" />
</li>
</ul>


</div> -->
      <span slot="title" v-html="pageTitle"></span>
      <div class="city-text" slot="text" style="color: #fff;
    font-size: 17px;
    opacity: 0.75;
    font-weight: 400;">
        <span v-if="branchedDormTitle" v-html="spot"></span>
      </div>
      <div class="subpage-header-inf" slot="numbers">
<!--         <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-dorm-female.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="universityDetails">{{ universityDetails.universities_count }}</strong>
            <span>Kız Öğr. Yurdu</span>
          </div>
        </div> -->

        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-dorm.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block">{{ total_results }}</strong>
            <span>Movies</span>
          </div>
        </div>
      </div>
      <div class="uni-detail__card" slot="right">
        <UniInfoCard v-if="branchDetails"
          :logo="branchDetails.logo"
        />
      </div>
    </subpage-header>
    <div class="subpage__inner mybackground">
      <div class="gen uni" ref="dormTab">
        <container>
          <div class="dorm-tab uni">
            <div class="dorm-tab__header">
              <!-- <DormTabNav :tabs="tabs"/> -->
<!--               <div class="desktop-drop">
                <div class="section__right">
                  <div class="section__select" >
                    <SelectBox2Old :options="districts" title="İlçe Seçiniz" @onselect="selectDistrict"/>
                  </div>
                </div>
              </div> -->
            </div>
            <router-view/>
          </div>
        </container>
      </div>
      <container>
        <div class="seo-text" v-if="universityDetails">
          <p v-html="universityDetails.list_seo"></p> <br>
          <v-link
            class="button--more color-white subpage-header__btn seo-btn"
            :title="`${universityDetails.name} Hakkında Merak Edinler`"
            icon="icon-arrow-long-right"
            icon-position="right"
            :to="{ name: 'UniDetailAbout', params: { slug: this.$route.params.slug }}"
            slot="button"
          />
        </div>
      </container>
    </div>
<Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title" >MESAJINIZ GÖNDERİLDİ!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">İlginiz İçin Teşekkür Ederiz.</span></p>
      <p ><span class= "mycolorBlue">Arkadaşlarımız en yakın zamanda sizinle iletişime geçecek.</span></p>
    </div>
     </div>
</div>
</Modal2>
         <Modal2 :active="showModal" @onModalClose="closeModal">
          <div slot="content">
        <div class="dorm-form__inner mydorm-form-inner ">
          <div class="dorm-form__form">
              <div class="dorm-form-tab">
                    <div icon="icon-mail" class="dorm-form-tab__item mycolor mycursor1">
                        <svg viewBox="0 0 20 20" class="icon" style="font-size: 30px; color: rgb(235, 96, 129);">
                            <use xlink:href="/icon/icons.svg#icon-fiyat-sor"></use>
                        </svg>
                        <div class="dorm-form-tab__title">YURTLAR BENİ ARASIN</div>
                        <!-- <div class="dorm-form-tab__title">{{ smsa21
                            rea }} YAKIN TÜM YURTLARDAN TEKLİF AL</div> -->
                    </div>
                </div>
             <div id="my-form" ref="myMessageForm" >
             <v-input ref="myInput"  placeholder="Ad Soyad" v-model="messageForm.name" v-on:keyup.native="saveForm"/>
            <label for="password" v-if="emptyName" class="myValidationText">Bu kısım boş geçilemez!</label>
             <v-select v-if="messageForm.university_name === 'Üniversite Seç' || messageForm.university_name === null || messageForm.university_name ===''" :options="universities" placeholder='Üniversite Seç' :title="messageForm.university_name" @onselect="selectUniversity"/>
             <VueSelectTempCity v-else :options="universities" placeholder='Üniversite Seç' :title="messageForm.university_name" @onselect="selectUniversity"/>
             <!-- <v-select :options="universities" placeholder="Üniversite Seçiniz" @onselect="selectUniversity"/> -->
             <label for="password" v-if="emptyUniversity" class="myValidationText">Bu kısım boş geçilemez!</label>
             <VueSelect2 v-if="messageForm.faculty_name === 'Fakülte Seç' && messageForm.university_name !='Üniversite Seç'" :options="faculties" placeholder='Fakülte Seç' @onselect="selectFacultyOnForm"/>
            <VueSelectTempFaculty v-else-if="facultyEnabled && messageForm.faculty_name !='Fakülte Seç'" placeholder="Fakülte Seç" :options="faculties"  @onselect="selectFacultyOnForm"/>
            <SelectBox2 v-else myplaceholder="Fakülte Seç" :options="faculties" :title="messageForm.faculty_name" @onselect="selectFacultyOnForm" disabled/>
            <label for="password" v-if="emptyFaculty" class="myValidationText">Bu kısım boş geçilemez!</label>
             <VueInputRestricted  placeholder="Telefon No" v-on:keyup.native="saveForm" v-model="messageForm.phone"/>
             <label for="phone" v-if="emptyPhone" class="myValidationText">Bu kısım boş geçilemez!</label>
             <label for="phone" v-if="falsePhone" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
             <label for="phone" v-if="shortPhone" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label>
             <v-input type="text" placeholder="E-Posta Adresi" v-on:keyup.native="saveForm" v-model="messageForm.email"/>
              <label for="password" v-if="falseEmail" class="myValidationText">Geçersiz e-posta formatı!</label>
              <label for="password" v-if="emptyEmail" class="myValidationText">Bu kısım boş geçilemez!</label>
              </div>
             <v-button
               class="red fw mt-15 dorm-form__submit"
               title="GÖNDER"
               @click.native="sendSmsAll()"
             />
           </div>
          </div>
        </div>
        </Modal2>
<BranchedDorms/> 
  </div>
</template>
<script>
import SubpageHeader from '@/components/SubpageHeader'
import FixedPopup from '@/components/FixedPopup'
import DormTabNav from '@/components/Branch/DormTabNavBranch'
import UniInfoCard from '@/components/Branch/BranchInfoCard'
import axios from 'axios'
import Modal2 from '@/components/Modal2'
import SelectBox2 from '@/components/SelectBox2'
import SelectBox2Old from '@/components/SelectBox2old'
import { mapGetters } from 'vuex'
import {
  GET_UNIVERSITY_DETAILS
} from '@/store/actions.type'
import Loading from 'vue-loading-overlay';
import VueInputRestricted from '@/components/VueInputRestricted'
import VueSelectTempCity from '@/components/VueSelectTempCity'
import VueSelectTempFaculty from '@/components/VueSelectTempFaculty'
import VueSelect2 from '@/components/VueSelect2'
import BranchedDorms from '@/components/Branch/BranchedDorms.vue'
export default {
  name: 'Branch',
  components: {
    SubpageHeader, DormTabNav, FixedPopup, UniInfoCard, Modal2, SelectBox2,SelectBox2Old, VueInputRestricted, Loading, VueSelectTempCity, VueSelectTempFaculty, VueSelect2, BranchedDorms
  },
   metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.branchDetails ? this.branchDetails.title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.branchDetails ? this.branchDetails.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.branchDetails ? this.branchDetails.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/' + this.city_url},
      ]      
    }
  },
  data () {
    return {
      branchDetails: null,
      cities: [],
      district: 'Select Discrict',
      districts: [],
      dormWeb: '',
      dormLogo: null,
      branchedDormTitle: '',        
      facultyEnabled: false,
      universities: [],
      faculties: [],
      showSuccessMessage: false,
      smsarea: '',
      list: '',
      list_id: '',
      isLoading: false,
      fullPage: true,
      showGetPrice: true,
      messageForm: {
        dorm_id: null,
        name: null,
        email: null,
        university_id: null,
        faculty_id: '',
        phone: null,
        university_name: 'Select Genre',
        faculty_name: 'Select SubGenre'
      },
      showModal: false,
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyEmail2: false,
      emptyUniversity: false,
      emptyFaculty: false,
      city_name: '',
      city_slug: '',
      city_url: '',
      university_url:'',
      gender1: 'erkek',
      tabs: [
        {
          id: 2,
          typeID: 2,
          cat: 'female',
          title: '<span class="color-pink">Kız <literal> Movies </literal>',
          icon: require('@/assets/img/icon-female.svg'),
          active: true
        },
        {
          id: 1,
          typeID: 1,
          cat: 'male',
          title: '<span class="color-blue">Erkek <literal> Movies </literal>',
          icon: require('@/assets/img/icon-male.svg'),
          active: false
        }
      ],
      gender: null,
      faculty: null,
      opt: {}
    }
  },
  methods: {  
    selectCity (slug) {
      this.districtEnabled = true
      let self = this
      axios.get(`/site/cities/${slug}`)
        .then(response => {
          self.districts = response.data.districts
        })
        .catch(e => {
          this.errors.push(e)
        }) 
    },
    saveForm () {
      window.localStorage.setItem('username', this.messageForm.name)
      window.localStorage.setItem('mail', this.messageForm.email)
      window.localStorage.setItem('phone1', this.messageForm.phone)
    },
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
},
    sendSmsAll() {
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      const verifiedMail = this.validateEmail(this.messageForm.email)
      var self = this
               if(this.isLogin === '') {
                this.universities.forEach((data) => {
            if(data.id == self.messageForm.university_id) {
                // self.university_name = data.name
                window.localStorage.setItem('university_name', data.name)
            }
            })
            if(this.messageForm.faculty_id && this.faculties) {
                this.faculties.forEach((data) => {
            if(data.id == self.messageForm.faculty_id) {
                // self.university_name = data.name
                window.localStorage.setItem('faculty_name', data.name)
            }
            })
}
              }

      if(!this.messageForm.email) {
        this.emptyEmail = true
      } else if(this.messageForm.email &&!verifiedMail) {
        this.falseEmail = true
      }
      if(!this.messageForm.name) {
        this.emptyName = true
      }
      if(!this.messageForm.phone) {
        this.emptyPhone = true
      }

      if(this.messageForm.phone && !this.messageForm.phone.startsWith("0")) {
        this.falsePhone = true
      }

      if(this.messageForm.phone && !this.falsePhone && this.messageForm.phone.length != 11) {
        this.shortPhone = true
      }

      if(!this.messageForm.university_id || this.messageForm.university_id == 'null') {
        this.emptyUniversity = true
      }

      if(!this.messageForm.faculty_id || this.messageForm.faculty_id == 'null') {
        this.emptyFaculty = true
      }

if (!this.emptyName && !this.emptyEmail && !this.falseEmail && verifiedMail && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyUniversity) {
          axios.post(`/site/dorm/message/multiple`, {
          email: this.messageForm.email,
          name: this.messageForm.name,
          phone: this.messageForm.phone,
          email: this.messageForm.email,
          university_id: this.messageForm.university_id,
          faculty_id: this.messageForm.faculty_id,
          list: this.list,
          list_id: this.list_id
        })
        .then(response => {
          this.closeModal()
          this.showSuccessMessage = true
//          this.isLoading = false

        })
        .catch(e => {
          self.errors.push(e)
        })
}
    },
    showSmsModal() {
      this.getUniversities()
      this.smsarea = ''
      if(this.faculty){
          this.smsarea = this.opt.name.toUpperCase() + 'NE'
          this.list = 'faculty'
          this.list_id = this.opt.id
      } else {
          this.smsarea = this.universityDetails.name.toUpperCase() + 'NE'
          this.list = 'university'
          this.list_id = this.messageForm.university_id
      }
          if (!window.localStorage.getItem('mail') || window.localStorage.getItem('mail') === '' || window.localStorage.getItem('mail') === 'null') {
            this.messageForm.email = ''
          } else {
          this.messageForm.email = window.localStorage.getItem('mail')
          }

          if (!window.localStorage.getItem('username') || window.localStorage.getItem('username') === '' || window.localStorage.getItem('username') === 'null') {
            this.messageForm.name = ''
          } else {
          this.messageForm.name = window.localStorage.getItem('username')
          }
          if (!window.localStorage.getItem('phone1') || window.localStorage.getItem('phone1') === '' || window.localStorage.getItem('phone1') === 'null') {
            this.messageForm.phone = ''
          } else {
          this.messageForm.phone = window.localStorage.getItem('phone1')
          }
          // email: window.localStorage.getItem('mail'),
          this.messageForm.university_id = window.localStorage.getItem('university_id')
          this.messageForm.faculty_id = window.localStorage.getItem('faculty_id')
          if (!window.localStorage.getItem('university_name') || window.localStorage.getItem('university_name') === '' || window.localStorage.getItem('university_name') === 'null') {
            this.messageForm.university_name = 'Select Studio'
            this.facultyEnabled = false
          } else {
             this.facultyEnabled = true
             this.messageForm.university_name = window.localStorage.getItem('university_name')
            let self = this
            axios.get(`/selected/faculties/${window.localStorage.getItem('university_id')}`)
              .then(response => {
                self.faculties = response.data
              })
                }
          if (!window.localStorage.getItem('faculty_name') || window.localStorage.getItem('faculty_name') === 'null' || window.localStorage.getItem('faculty_name') === 'null') {
            this.messageForm.faculty_name = 'Fakülte Seç'
          } else {
          this.messageForm.faculty_name = window.localStorage.getItem('faculty_name')
          }


      this.showModal = true
      this.showGetPrice = false
    },
    closeModal() {
      this.showModal = false
      this.showGetPrice = true
    },
    closeModal2() {
      this.showSuccessMessage = false
    },
    checkFaculty () {
      if (!this.$route.params.faculty) {
        this.faculty = null
      }
    },
    checkGender () {
      if (this.$route.params.type === 'erkek') {
        this.gender = 'Erkek'
        this.typeID = 1
        this.gender1 = 'erkek'
      } else if (this.$route.params.type === 'kiz') {
        this.gender = 'Kız'
        this.typeID = 2
        this.gender1 = 'kiz'
      } else {
        this.gender = null
        // this.faculty = null
      }
    },
    setCityName(city_id) {
      let self = this
      axios.get('/site/cities/cities')
          .then(response => {
              //self.universities =
              response.data.forEach((data) => {
            if(data.id === city_id) {
              // window.localStorage.setItem('university_name', data.name)
              // ''self.messageForm.university_name = window.localStorage.getItem(data.name)
              self.city_name = data.name
              self.city_slug = self.getCitySlug(data.name)
              self.city_url = '/' + window.localStorage.getItem('city') + '-ozel-ogrenci-yurtlari/'
              // self.university_url = '/' + self.universityDetails.slug  + '-yakin-ogrenci-yurtlari/'
            }
            })
            })
              .catch(e => {
              this.errors.push(e)
            })
        },
    getCitySlug(city_name) {
                    //if(this.city_name !='') {
                        let str = city_name.toLowerCase()
                        str = str.replace('ş', 's')
                        str = str.replace('ı', 'i')
                        str = str.replace('ğ', 'g')
                        str = str.replace('ü', 'u')
                        str = str.replace('ö', 'o')
                        return str
/*                     } else {
                        return ''
                    } */

                },
    selectUniversity (opt) {
      this.facultyEnabled = true
      this.messageForm.university_id = opt.id
      this.messageForm.university_name = opt.name
      window.localStorage.setItem('university_id', opt.id)
      window.localStorage.setItem('university_name', opt.name)
      let self = this
      axios.get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectFacultyOnForm (opt) {
      this.messageForm.faculty_name = opt.name
      window.localStorage.setItem('faculty_id', opt.id)
      window.localStorage.setItem('faculty_name', opt.name)
    },
    selectDistrict (opt) {
      this.district = opt.name
      this.opt = opt
      window.localStorage.setItem('district', opt.name)
      let slug= window.localStorage.getItem('slug')
      // let dorm = this.string_to_slug(this.branchedDormTitle)

      let route = null
      if(opt.name === 'Tüm İlçeler') {
        route = { name: 'Branch', params: { dorm: slug} }
        this.$router.push(route)
      } else {
        if(this.$route.params.type) {
         route = { name: 'BranchDistrictGender', params: { district:opt.slug, type: this.$route.params.type } }
        } else {
           route = { name: 'BranchDistrict', params: { dorm: slug, district: opt.slug} }
        }
      this.$router.push(route)
      }
      

      // this.$emit('selectCity', opt)
    },    
    getUniversities() {
          var self = this
      axios.get('/selected/universities')
        .then(response => {
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    filterFaculty (faculty) {
      return this.universityDetails.faculties.find((item) => item.slug === faculty)
    },
    getCities () {
      let self = this
      axios.get('/site/home/select-cities')
        .then(response => {
          self.cities = response.data
              let city_id = window.localStorage.getItem('city_id')
          self.city_name = this.cities.find(function (city) { return city_id == city.id } ).name
        })
        .catch(e => {
          this.errors.push(e)
        })
    }    
  },
  computed: {
    ...mapGetters(['universityDetails', 'total_results']),
    pageTitle () {
      let branchedDormTitle = this.$route.params.title
      
      let titleTemplate = 'Movies'
      /*
        if (this.branchedDormTitle && this.branchedDormTitle.includes('Kız ve Erkek Öğrenci Yurtları')) {
        branchedDormTitle = this.branchedDormTitle.replace('Kız ve Erkek Öğrenci Yurtları','')
        titleTemplate = 'Kız ve Erkek Öğrenci Yurtları'
      }      
        else if (this.branchedDormTitle && this.branchedDormTitle.includes('Kız Öğrenci Yurtları')) {
        branchedDormTitle = this.branchedDormTitle.replace('Kız Öğrenci Yurtları','')
        titleTemplate = 'Kız Öğrenci Yurtları'
      } else if (this.branchedDormTitle && this.branchedDormTitle.includes('Erkek Öğrenci Yurtları')) {
        branchedDormTitle = this.branchedDormTitle.replace('Erkek Öğrenci Yurtları','')
        titleTemplate = 'Erkek Öğrenci Yurtları'
      } else if (this.branchedDormTitle && this.branchedDormTitle.includes('Özel Öğrenci Yurtları')) {
        branchedDormTitle = this.branchedDormTitle.replace('Özel Öğrenci Yurtları','')
        titleTemplate = 'Özel Öğrenci Yurtları'
        } else if (this.branchedDormTitle && this.branchedDormTitle.includes('Kız Yurtları')) {
        branchedDormTitle = this.branchedDormTitle.replace('Kız Yurtları','')
        titleTemplate = 'Kız Yurtları'
        } else if (this.branchedDormTitle && this.branchedDormTitle.includes('Erkek Yurtları')) {
        branchedDormTitle = this.branchedDormTitle.replace('Erkek Yurtları','')
        titleTemplate = 'Erkek Yurtları'
      }      
      else if(this.branchedDormTitle && this.branchedDormTitle.includes('Öğrenci Yurtları')) {
        branchedDormTitle = this.branchedDormTitle.replace('Öğrenci Yurtları','')
        titleTemplate = 'Öğrenci Yurtları'
      } else if (this.branchedDormTitle && this.branchedDormTitle.includes('Yurtları')) {
        branchedDormTitle = this.branchedDormTitle.replace('Yurtları','')
        titleTemplate = 'Yurtları'
      } 
*/
      let district = this.district
      if(this.district === 'Tüm İlçeler') {
          district = ''
      }
      
      let title = `<span class="color-light-green">${branchedDormTitle} </span>${titleTemplate}`
/*
      if (this.gender && this.district != 'İlçe Seçiniz') {
        title = `<span class="color-light-green">${branchedDormTitle} </span> ${district}  ${this.gender} ${titleTemplate}`
      }      
      else if (this.gender) {
        const slug = window.localStorage.getItem('slug')
       if(slug.includes('-kiz-') && slug.includes('-erkek-')) {
      let c = 5
  } else {
        title = `<span class="color-light-green">${branchedDormTitle} </span> ${this.gender} ${titleTemplate}`
  }

      }
      else if (this.district != 'İlçe Seçiniz' && this.district != 'Tüm İlçeler') {
        title = `<span class="color-light-green">${branchedDormTitle} </span> ${district} ${titleTemplate}`
      } 
*/
      return title
    },
    spot () {
      const desc = window.localStorage.getItem('description')
  //    let title = this.branchedDormTitle + ' şubeleri hakkında bilgi al, en uygun oda fiyatlarını öğren!'  // this.universityDetails.spot
      
/*       const route = this.$route.params
      if (route.faculty) {
        const faculty = this.filterFaculty(route.faculty)
        if (this.gender === 'Erkek') {
          title = faculty.male_spot
        } else if (this.gender === 'Kız') {
          title = faculty.female_spot
        } else {
          title = faculty.spot
        }
      } else if (this.gender) {
        if (this.gender === 'Erkek')
          title = this.universityDetails.male_spot
        } else if (this.gender === 'Kız') {
          title = this.universityDetails.female_spot
        }
      } */
      return desc
    }
  },
  created () {
    this.branchedDormTitle = this.$route.params.title
    // this.getCities()
    // let city_slug = window.localStorage.getItem('city')
    // this.selectCity(city_slug)
    // this.checkGender()
    // const id = window.localStorage.getItem('branchedDormId')
  //  this.branchDetails.name = this.$route.params.name
    const id = this.$route.fullPath.split('-s-')
    var self = this
      
      /*const url = `/site/dorm/branches/${id[1]}`
       // let distinctArray = null
       axios.get(url)
         .then(response => {
           //self.dormLogo = response.data.logo
           window.localStorage.setItem('dormLogo', response.data.logo)
           this.branchDetails = response.data  //.branches
    }) 
        this.branchedDormTitle = window.localStorage.getItem('branchedDormTitle')
        // this.branchedDormTitle = branchedDormTitle.replace('Movies', '')
        this.city_name = window.localStorage.getItem('city')
        this.dormWeb = window.localStorage.getItem('dormWeb')
*/
/*
        this.branchDetails.dorms_count = window.localStorage.getItem('branchnumber')
        this.branchDetails.title = window.localStorage.getItem('branchedDormTitle')
        this.branchDetails.description = window.localStorage.getItem('center_description')
        this.branchDetails.keywords = window.localStorage.getItem('center_keywords')
*/
        // ilk karakter İ ise

        let city = window.localStorage.getItem('city')
        this.city_url = '/' + city + '-movies/'
/*         if(city && city.charAt(0) === 'i') {
          this.branchDetails.city = 'İ' +city.slice(1)
        } else {
          this.branchDetails.city = city.charAt(0).toLocaleUpperCase() + city.slice(1)
        } */
        
  },
/*   watch: {
    $route () {
      this.checkGender()
    }
  } */
}
</script>

<style lang="scss">
  @import "../../assets/scss/components/city";

    .mytitle1 {
    font-size: 15px;
    color:white;
  }

modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  height: 45%;
}
.mydorm-form-inner {
  background-color: white,
}

.myli {
  display: inline-block;
}

.mytitleUni {
  font-size: 12px;
  color:white;
}

  .my1 {
    padding: 10px 20px !important;
  //  padding-bottom: 5px;
    bottom: 10px;
    position: left;
  }
  
  .mybackground {
    background: #eff3fb;    
  }
</style>
